// extracted by mini-css-extract-plugin
module.exports = {"electionLiveBlogs":"A1UfF","electionLiveBlogsTitle":"rtkHV","elbMianTitle":"FUGfW","linkWrap":"hivRq","links":"NiYzM","elbSubTitle":"jvPw5","electionLiveBlogsInner":"XV2C1"};